import React, { FC } from "react";
import { ComponentProps } from "../../../types/components";

export type FlashSaleProps = ComponentProps & {
  title: string;
  description: string;
};

export const withFlashSale =
  (Component: FC<FlashSaleProps>) =>
  ({ name = "FlashSale", title, description }: FlashSaleProps) => {
    Component.displayName = name;
    return <Component title={title} description={description} />;
  };
